import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AuthArtwork from 'src/layouts/AuthArtwork';
import { AUTH_FLOW_ARTWORK, AuthFlowScreen } from './content';
import {
  FlowArtwork,
  FlowHeading,
  FlowHeadingLine,
  FlowWelcome,
} from './styles';

interface AuthFlowWelcomeProps {
  screen: AuthFlowScreen;
  wide: boolean;
  onArtworkReady: () => void;
}

export default function AuthFlowWelcome({
  screen,
  wide,
  onArtworkReady,
}: AuthFlowWelcomeProps): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <FlowWelcome
      data-testid="auth-flow-welcome"
      aria-labelledby="auth-flow-welcome-title"
    >
      <FlowHeading>
        <Typography
          id="auth-flow-welcome-title"
          component="h2"
          variant="h2"
          sx={{
            fontWeight: 800,
            lineHeight: 1.08,
            letterSpacing: '-0.04em',
            fontSize: {
              lg: theme.typography[wide ? 'h3' : 'h2'].fontSize,
              xl: theme.typography[wide ? 'h2' : 'h1'].fontSize,
            },
          }}
        >
          <FlowHeadingLine>{t(`authFlow.${screen}.line1`)}</FlowHeadingLine>
          <br />
          <FlowHeadingLine>{t(`authFlow.${screen}.line2`)}</FlowHeadingLine>
        </Typography>
      </FlowHeading>
      <FlowArtwork data-testid="auth-flow-illustration" aria-hidden="true">
        <AuthArtwork
          {...AUTH_FLOW_ARTWORK[screen]}
          onArtworkReady={onArtworkReady}
        />
      </FlowArtwork>
    </FlowWelcome>
  );
}
